// @flow
import React, { Component } from 'react';
import DealerToolboxModel from 'Stores/DealerToolboxModel';
import { getGivenBackground } from 'Utils/getColor/index';
import IntroText from 'Components/IntroText';
import DefaultPage from 'Containers/DefaultPage';
import ErrorPage from 'Containers/ErrorPage';
import HeroHeader from 'Components/HeroHeader';
import { Chessboard, ChessboardItem } from 'Components/Chessboard';
import styles from './styles.scss';
import ConsumptionData from 'Components/ConsumptionData';

type Props = {
  opOpenContact: () => void,
  toolbox: DealerToolboxModel,
};

export default class DealerToolboxDetails extends Component<Props> {
  render() {
    const { data: rawToolbox, onOpenContact } = this.props;

    if (!rawToolbox) {
      return <ErrorPage />;
    }

    const toolbox = new DealerToolboxModel(rawToolbox);
    const ctas = toolbox.getAllCtas();
    const { pathname } = window.location;

    return (
      <DefaultPage background={getGivenBackground('white')}>
        <HeroHeader
          image={toolbox.heroImage}
          title={toolbox.heroTitle}
          // we do some magic with pathname to cut out the last subpath
          // slice from 0 to the last index of / (ignoring a trailing / if exists)
          // f.e. /abc/def/ghi => /abc/def/
          backlink={pathname.slice(
            0,
            pathname.slice(0, pathname.endsWith('/') ? -1 : undefined).lastIndexOf('/')
          )}
        />

        {toolbox.consumptionText && <ConsumptionData consumptionText={[toolbox.consumptionText]} />}

        {toolbox.hasModule('intro') && (
          <IntroText
            onOpenContact={onOpenContact}
            title={toolbox.introTitle || ''}
            text={toolbox.introText || ''}
            cta1={ctas.introCta1}
            cta2={ctas.introCta2}
          />
        )}

        <Chessboard>
          <ChessboardItem
            flex
            onOpenContact={onOpenContact}
            entry={{ image: toolbox.offerImage }}
            cta={{ ...ctas.offerCta1 }}
            cta2={{ ...ctas.offerCta2 }}
          >
            <div>
              {toolbox.offerTitle && <h3 className={styles.headline}>{toolbox.offerTitle}</h3>}

              {/**
               * used a div since Fragment does not support it
               * see https://github.com/facebook/react/issues/12014
               */}
              <div dangerouslySetInnerHTML={{ __html: toolbox.offerText }} />
            </div>
          </ChessboardItem>
        </Chessboard>

        {toolbox.hasModule('closing') && (
          <IntroText
            onOpenContact={onOpenContact}
            title={toolbox.closingTitle || ''}
            text={toolbox.closingText || ''}
            cta1={ctas.closingCta1}
            cta2={ctas.closingCta2}
          />
        )}
      </DefaultPage>
    );
  }
}
